/* eslint-disable react/prop-types */
import classes from './Frame.module.scss' ;
import {Container , Row , Col  } from 'react-bootstrap'  ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUserPlus , faBedPulse , faHandHoldingMedical} from '@fortawesome/free-solid-svg-icons'
import {useEffect,useState} from 'react';
import ScrollTrigger from 'react-scroll-trigger' ;

function Frame({fImg}) {
    //=========================== update
    const [counter, setCounter] = useState(0);
    const [counter2, setCounter2] = useState(50_000_000 -52 * 10_000); //50,000,000
    const [counter3, setCounter3] = useState(10_000-52 * 100); //10,000
    const [counterOn, setCounterOn] = useState(false); 

    //----------------
    useEffect(() => {
        if(counterOn){
            if(counter<52){
                const interval = setInterval(() => {
                    setCounter((prevCounter) => prevCounter +1);
                    setCounter2((prevCounter) => prevCounter +10_000);
                    setCounter3((prevCounter) => prevCounter +100);
                },40);
                return () => clearInterval(interval);
            }else{
                return
            }
        }else{
            setCounter(0);
            setCounter2(50_000_000 -52 *10_000);
            setCounter3(10_000 - 52 *100);
        }
    },[counter , counterOn])
    //===========================
    return (
        <section className={`${classes["section__container"]} `}>
            {/* <div className={`${classes["container"]} `}>
                <img src={fImg} alt="img" />
            </div> */}
            <ScrollTrigger onEnter={()=>{setCounterOn(true)}} onExit={()=>{setCounterOn(false)}}>
            <Container className={`mt-5 mb-5`}>
                <Row md={3} xs={1} lg={3} className={`g-5 p-md-3  justify-content-center mt-5`}>
                    <Col className={`${classes['contact-col']} d-flex align-center justify-content-center`}>
                        <p className={classes["section__subheader_2"]}><span className={classes["num"]}>{counter.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + " +"}</span> countries around the world and expanding .</p>
                        <div className={`${classes.icon}`}>
                            <FontAwesomeIcon icon={faUserPlus} size="xl" style={{color: "#ccecee",}} />
                        </div>
                    </Col>
                    <Col className={`${classes['contact-col']} d-flex align-center justify-content-center`}>
                        <p className={classes["section__subheader_2"]}><span className={classes["num"]}>{counter2.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + " +"}</span>patients served .</p>
                        <div className={`${classes.icon}`}>
                            <FontAwesomeIcon icon={faBedPulse} size="xl" style={{color: "#ccecee",}}/>
                        </div>
                    </Col>
                    <Col className={`${classes['contact-col']} d-flex align-center justify-content-center`}>
                        <p className={classes["section__subheader_2"]}><span className={classes["num"]}>{counter3.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + " +"}</span>Healthcare professionals.</p>
                        <div className={`${classes.icon}`}>
                            <FontAwesomeIcon icon={faHandHoldingMedical} size="xl" style={{color: "#ccecee",}} />
                        </div>
                    </Col>
                </Row>
            </Container>
            </ScrollTrigger>
        </section>
    )
}

export default Frame
